import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    fetchComplaints,
} from '../../app/reducers/Complaints/complaintSlice';
import {
    fetchEmployees,
    getEmployees,
} from '../../app/reducers/Users/EmployeeSlice';
import ModalBasic from '../../components/infrastructure/Modals/ModalBasic';
import PrimaryButton from '../../components/infrastructure/Buttons/PrimaryButton';
import FormikSelectGroup from '../../components/formik/FormikSelectGroup';
import FormikInputGroup from '../../components/formik/FormikInputGroup';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { generateEmployeeOptions } from '../../utils/Utils';
import { authAxiosInstance } from '../../utils/axiosConfig';
import QueryString from 'qs';

const ChangeAssignedTechnicianModal = ({ isChangeAssignedModalOpen, setIsChangeAssignedModalOpen, complaintId }) => {
    const dispatch = useDispatch();
    const { employees } = useSelector(getEmployees); // that redux call from it parent 
    const [complaintData, setComplaintData] = useState({});


    const fetchComplaintData = async () => {
        if (!complaintId) return;
        try {
            const resp = await authAxiosInstance.get(`/complaint?${QueryString.stringify({ _id: complaintId, populate: true })}`);
            setComplaintData(resp?.data?.data?.docs?.[0] || {});
        } catch (error) {
            console.log('error fetching complaint', error);
        }
    };

    useEffect(() => {
        if (!isChangeAssignedModalOpen) return;
        fetchComplaintData();
    }, [complaintId, isChangeAssignedModalOpen]);

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            _id: complaintData?._id || '',
            currentAssignedTo: complaintData?.assignedTo || '',
            assignedId: '',
            assignedTo: '',
            changeAssignedNotes: '',
        },
        validationSchema: Yup.object({
            assignedId: Yup.string().required('Please select a technician'),
            changeAssignedNotes: Yup.string().required('Note is required'),
        }),
        onSubmit: async (values) => {
            await authAxiosInstance.patch('/complaint/change-assigned', {
                _id: values._id,
                assignedId: values.assignedId,
                assignedTo: values.assignedTo,
                changeAssignedNotes: values.changeAssignedNotes,
            });
            await dispatch(fetchComplaints({ populate: true }));
            setIsChangeAssignedModalOpen(false);
            formik.resetForm();
            setComplaintData({});
        },
    });

    return (
        <ModalBasic
            title={`Change Assigned Technician`}
            setModalOpen={setIsChangeAssignedModalOpen}
            modalOpen={isChangeAssignedModalOpen}
            max_width="max-w-lg"
        >
            <form
                onSubmit={formik.handleSubmit}
                className="flex flex-col gap-4 p-5 min-h-[260px]"
            >
                <FormikInputGroup formik={formik} label="Current Technician" name="currentAssignedTo" readOnly />

                <FormikSelectGroup
                    label="Select New Technician"
                    name="assignedId"
                    formik={formik}
                    options={generateEmployeeOptions(employees?.docs)}
                    required
                    onChange={(selectedOption) => {
                        formik.setFieldValue('assignedId', selectedOption.value);
                        formik.setFieldValue('assignedTo', selectedOption.label);
                    }}
                />
                <FormikInputGroup
                    formik={formik}
                    name="changeAssignedNotes"
                    label="Change Assigned Note"
                    required
                />
                <div className="mt-auto">
                    <PrimaryButton
                        type="submit"
                        disabled={formik.isSubmitting}
                        className=""
                    >
                        {formik.isSubmitting ? 'Saving...' : 'Submit'}
                    </PrimaryButton>
                </div>
            </form>
        </ModalBasic>
    );
};

export default ChangeAssignedTechnicianModal;
